import {
  TEXT_LINE_INPUT,
  TEXT_BOX_INPUT,
  SPACE_LAYOUT,
  DIVIDER_LAYOUT,
  COMMENT_LAYOUT,
  DATE_INPUT,
  DATE_TIME_INPUT,
  CHECKBOXES_INPUT,
  RADIO_BUTTONS_INPUT,
  DROPDOWN_INPUT,
  TEXT_GROUP_NAME,
  LAYOUT_GROUP_NAME,
  DATE_TIME_GROUP,
  SELECTORS_GROUP,
  OTHER_GROUP,
  SIGNATURE_INPUT,
} from 'app/types/form-builder';

const INCIDENT_REPORT_INPUT_GROUPS = [
  {
    name: TEXT_GROUP_NAME,
    items: [TEXT_LINE_INPUT, TEXT_BOX_INPUT],
  },
  {
    name: LAYOUT_GROUP_NAME,
    items: [COMMENT_LAYOUT, SPACE_LAYOUT, DIVIDER_LAYOUT],
  },
  {
    name: DATE_TIME_GROUP,
    items: [DATE_INPUT, DATE_TIME_INPUT],
  },
  {
    name: SELECTORS_GROUP,
    items: [CHECKBOXES_INPUT, RADIO_BUTTONS_INPUT, DROPDOWN_INPUT],
  },
  {
    name: OTHER_GROUP,
    items: [SIGNATURE_INPUT],
  },
];

const INCIDENT_REPORT_USER_TYPES = {
  CREATOR: 'CREATOR',
  REVIEWER: 'REVIEWER',
};

export { INCIDENT_REPORT_INPUT_GROUPS, INCIDENT_REPORT_USER_TYPES };
